import React, { useEffect } from 'react';
import type { RenderModalWrapperProps } from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useQuickSearchAnalyticsAttributes } from '../../../../controllers/use-quick-search-analytics/index.tsx';
import { QuickSearchWrapper } from '../../../../controllers/use-quick-search-analytics/wrapper/index.tsx';
import { QuickSearchFireScreenAnalytics } from './fire-screen-analytics/index.tsx';

export const QuickSearchChildWrapper = ({
	children,
}: RenderModalWrapperProps): React.JSX.Element => {
	const [attributes, { reset }] = useQuickSearchAnalyticsAttributes();

	useEffect(() => {
		reset();
		return () => {
			reset();
		};
	}, [reset]);

	const shouldFireScreenAnalytics = attributes.queryVersion >= 0;
	return (
		<QuickSearchWrapper>
			{shouldFireScreenAnalytics && <QuickSearchFireScreenAnalytics />}
			{children}
		</QuickSearchWrapper>
	);
};
